import type { Answers, BorrowerScenario } from '../types/application';

// Overrides layered on top of initialAnswers to preview each borrower journey.
export const scenarioOverrides: Record<BorrowerScenario, Partial<Answers>> = {
  underContract: {},
  shopping: {
    propertyStage: 'looking',
    propertyStreet: '',
    propertyCity: '',
    propertyZip: '',
    closingDate: '',
    price: 425000,
    downPayment: 85000,
  },
  refinance: {
    goal: 'refinance',
    propertyStage: '',
    price: 480000,
    downPayment: 160000,
    propertyStreet: '2215 Oak Hollow Dr',
    propertyCity: 'Round Rock',
    propertyState: 'TX',
    propertyZip: '78681',
    closingDate: '',
    currentStreet: '2215 Oak Hollow Dr',
    currentCity: 'Round Rock',
    currentState: 'TX',
    currentZip: '78681',
    yearsAtAddress: '6',
    housing: 'own',
    rent: '',
  },
};
